import { PaginationRequest } from '../pagination-request';

export class TenantRequest extends PaginationRequest {

}
